import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** 10Gアップグレード導線で使うトークン関連情報。 */
export type UpgradeTokenInfoStateType = {
  serviceid: string;
  ispcnno: string;
  linkstate: string;
  startdate: string;
};

/**
 * 10Gアップグレード申込で利用する識別情報を保持する state。
 * サービスIDや紐づけ状態を複数画面で参照するため、申込導線中はセッションへ保持する。
 */
export const UpgradeTokenInfoState = atom<UpgradeTokenInfoStateType>({
  key: 'UpgradeTokenInfoState',
  default: {
    serviceid: '',
    ispcnno: '',
    linkstate: '',
    startdate: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default UpgradeTokenInfoState;
